export default "__VITE_ASSET__a6753920__"